import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import "uikit/dist/css/uikit.min.css";
import "uikit/dist/js/uikit.min.js";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
